import ImportTool from "components/tools/import-tool/ImportTool";
import { useMissionBillContext } from "api/mission/mission-bills/MissionBillsProvider";
import { useState } from "react";
import {
  BILLING_MAX_FILE_SIZE,
} from "constants/constants";
import AlertPopup from "components/alert-popup/AlertPopup";

const InputsImportBilling = () => {
  const {
    importExcelFacturations,
    importExcelFacturationsStatus,
    setImportExcelFacturationsStatus,
    progression,
    setProgression,
    serverResponse,
    setServerResponse,
  } = useMissionBillContext();
  const [code, setCode] = useState();
  const [status, setStatus] = useState();

  return (
    <>
      <AlertPopup
        code={code}
        setCode={setCode}
        setStatus={setStatus}
        status={status}
      />
      <ImportTool
        queryStatus={importExcelFacturationsStatus}
        query={importExcelFacturations}
        setQueryStatus={setImportExcelFacturationsStatus}
        progression={progression}
        setProgression={setProgression}
        setCode={setCode}
        setStatus={setStatus}
        serverResponse={serverResponse}
        setServerResponse={setServerResponse}
        fileSizeLimit={BILLING_MAX_FILE_SIZE}
      />
    </>
  );
};

export default InputsImportBilling;
